import { defineStore } from 'pinia';

export interface ILocaleState {
  // Persisted base language: written by explicit choices and login sync, never by browser detection (which re-runs each load).
  persistedLanguage: string | null;
}

export const useLocaleStore = defineStore('locale', {
  actions: {
    setPersistedLanguage(language: string): void {
      this.$patch((state) => {
        state.persistedLanguage = language;
      });
    },
  },

  state: (): ILocaleState => ({
    persistedLanguage: null,
  }),

  persist: true,
});
